export default __webpack_public_path__ + "72f3bcbc9665de3ab0c768c8c28b88a0.png";